module.exports = __webpack_public_path__ + "static/img/logo@2x.c9c7f20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/JuneRecharge/logo@2x.png
// module id = LIeS
// module chunks = 70